import { useState, useEffect } from "react";

/**
 * Generic debounce hook
 * @param value - the value to debounce
 * @param delay - debounce delay in ms (default: 500)
 * @returns debouncedValue
 */
export function useDebounce<T>(value: T, delay: number = 500): T {

 
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler); // cleanup on value/delay change
  }, [value, delay]);

  return debouncedValue;
}
